import { GameElement } from "./gameElementTypes";
import { TrainingLevel } from "./playerAccount";

export const ImmuneCellClass = [
	[ // Level 1
		GameElement.SIMPLE,
		GameElement.WALL,
		GameElement.SEEKER,
		GameElement.ORBITER,
		GameElement.INCOME,
		GameElement.MARTYR,
		GameElement.SHOOTER
	], [ // Level 2
		GameElement.ELECTRIC,
		GameElement.BUFFER_MAGNET,
		GameElement.CHAINER,
		GameElement.BCELL,
		GameElement.COLOR_GROW_WALL,
		GameElement.BOMB,
		GameElement.PIERCE_SHOOTER
	], [ // Level 3
		GameElement.MONEY_WALL,
		GameElement.ELECTRIC_HUNGRY_GENERATOR,
		GameElement.GROW_BOMB,
		GameElement.SWAPPER_CHAIN,
		GameElement.AIM_SHOOTER,
		GameElement.SCAPEGOAT_CHAIN,
		GameElement.TAG_ORBITER,
		GameElement.TAG_SPRAYER,
	], [ // Level 4
		//GameElement.INTEREST,
		GameElement.TAG_PROOF_SEEKER,
		GameElement.ELECTRIC_KINETIC_GENERATOR,
		GameElement.MORTAR,
		GameElement.THORN_WALL,
		GameElement.HEAVY_CHAINER
	], [ // Level 5
		GameElement.HEALER,
		GameElement.WIND_SHOOTER,
		GameElement.SEEKER_FACTORY,
		GameElement.MONEY_BOMB_TURRET
	]
];

/*
 * Reward cells that are on offer, can probably be expanded to offer different cells at different player levels
 */
export const RewardCellClass = [ //Ok if reward cell distribution are not even, even preferred so you can get things early and build around them
	// Level 1
	[
		GameElement.BULLET_WALL,
		GameElement.SPOTTER_CHAIN,
		GameElement.COLOR_BUFFER,
		GameElement.STEM_CELL,
	],
	// Level 2
	[
		GameElement.CONSUME_BOMB,
		GameElement.COLOR_BOOSTER,
		GameElement.TAG_SEEKER_SPLITTER,
		GameElement.SENTRY_ORBITER,
		GameElement.PUSHER,
	],
	// Level 3
	[
		GameElement.COOLDOWN_ACCELLERATOR,
		GameElement.TAG_DRAG_DROPPER,
		GameElement.KINETIC_CHAIN_BUFFER,
		GameElement.MONEY_PRINTER,
	],
	// Level 4
	[
		GameElement.BIG_SHOOTER,
		GameElement.ELECTROMAGNET,
		GameElement.ELECTRIC_GENERATOR_WALL, //good, but would rather nerf
		GameElement.WILDCARD, //maybe move lower based on feeling of how often triples happen
	],
	// Level 5
	[
		// this would be something you see very rarely
	]
];

export const TutorialTiers = [
	[ // Level 1
		GameElement.WALL,
		GameElement.SEEKER,
	], [ // Level 2
		GameElement.CHAINER,
		GameElement.BOMB,
	], [ // Level 3
		GameElement.SCAPEGOAT_CHAIN, //in practice unlikely to see it
	], [ // Level 4
		GameElement.HEAVY_CHAINER
	], [ // Level 5
		GameElement.HEALER, //if they manage to get to level 5 in tutorial give em everything
		GameElement.WIND_SHOOTER,
		GameElement.SEEKER_FACTORY,
		GameElement.MONEY_BOMB_TURRET
	]
];

export const TutorialTwoAdds = [
	[ // Level 1
		GameElement.MARTYR,
		GameElement.SHOOTER
	], [ // Level 2
		GameElement.COLOR_GROW_WALL,
		GameElement.PIERCE_SHOOTER
	], [ // Level 3
		GameElement.AIM_SHOOTER,
	], [ // Level 4
	], [ // Level 5
	]
];

export const TutorialThreeAdds = [
	[ // Level 1
		GameElement.SIMPLE,
	], [ // Level 2
		GameElement.ORBITER,
		GameElement.ELECTRIC,
	], [ // Level 3
		GameElement.GROW_BOMB,
		GameElement.ELECTRIC_HUNGRY_GENERATOR,
	], [ // Level 4
		GameElement.MORTAR,
	], [ // Level 5
	]
];

export const TutorialRewardCellClass = [
	// Level 1
	[
		GameElement.COLOR_BUFFER,
		GameElement.STEM_CELL,
		GameElement.SENTRY_ORBITER, //made more common and lower tier in tutorial
	],
	// Level 2
	[
		GameElement.CONSUME_BOMB,
		GameElement.COLOR_BOOSTER,
	],
	// Level 3
	[
		GameElement.COOLDOWN_ACCELLERATOR,
		GameElement.KINETIC_CHAIN_BUFFER,
		GameElement.WILDCARD, //made more common and lower tier in tutorial
	],
	// Level 4
	[
		GameElement.BIG_SHOOTER,
		GameElement.ELECTRIC_GENERATOR_WALL,
	],
	[] // Level 5
];

//Putting this here to avoid importing gameElementTypes in constants
export const VirusOrderByTutorialLevel = [
	[GameElement.VIRUS, GameElement.VIRUS, GameElement.WAVE],
	[GameElement.VIRUS, GameElement.VIRUS, GameElement.WAVE, GameElement.AVOIDER],
	[GameElement.VIRUS, GameElement.VIRUS, GameElement.WAVE, GameElement.AVOIDER, GameElement.AOE_VIRUS],
];


//Build list of all immune cells in actual use

export function getDifferenceFromLastTrainingLevel(trainingLevel: TrainingLevel) {
	switch (trainingLevel) {

		case TrainingLevel.NewPlayer:
			return listAllCellsInTierList(TutorialTiers);
		case TrainingLevel.SecondGame:
			return listAllCellsInTierList(TutorialTwoAdds);
		case TrainingLevel.MultiplayerIntro:
			return listAllCellsInTierList(TutorialThreeAdds);

		case TrainingLevel.Trained: //find the difference from the tutorial cells dynamically
			const allImmuneCellsInGame = listAllCellsInTierList(ImmuneCellClass)
				.concat(listAllCellsInTierList(RewardCellClass));

			const cellsInTutorial = new Set();
			const tutorialCells = listAllCellsInTierList(TutorialTiers);
			for (let i = 0; i < tutorialCells.length; ++i) {
				cellsInTutorial.add(tutorialCells[i]);
			}
			const tutorialTwoAddsCells = listAllCellsInTierList(TutorialTwoAdds);
			for (let i = 0; i < tutorialTwoAddsCells.length; ++i) {
				cellsInTutorial.add(tutorialTwoAddsCells[i]);
			}
			const tutorialThreeAddsCells = listAllCellsInTierList(TutorialThreeAdds);
			for (let i = 0; i < tutorialThreeAddsCells.length; ++i) {
				cellsInTutorial.add(tutorialThreeAddsCells[i]);
			}
			const allTutorialRewardCells = listAllCellsInTierList(TutorialRewardCellClass);
			for (let i = 0; i < allTutorialRewardCells.length; ++i) {
				cellsInTutorial.add(allTutorialRewardCells[i]);
			}

			return Array.from(allImmuneCellsInGame.filter(cell => !cellsInTutorial.has(cell)));
	}

}

function listAllCellsInTierList(tierList: GameElement[][]): GameElement[] {
	const allCells: GameElement[] = [];
	for (let i = 0; i < tierList.length; ++i) {
		for (let j = 0; j < tierList[i].length; ++j) {
			allCells.push(tierList[i][j]);
		}
	}
	return allCells;
}	